import { AfterContentInit, Component, ContentChildren, QueryList, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { TabService } from '../tab/tab.service';
import { TabViewItemComponent } from '../tab-view-item/tab-view-item.component';

@Component({
  selector: 'ui-tab-view',
  templateUrl: './tab-view.component.html'
})
export class TabViewComponent implements AfterContentInit, OnInit, OnDestroy {
  @ContentChildren(TabViewItemComponent)
  tabViewItems: QueryList<TabViewItemComponent>;

  private subs: Array<Subscription> = [];
  private index = 0;

  constructor(private tabService: TabService) {
  }

  ngOnInit(): void {
    this.subs.push(this.tabService.tabIndex.subscribe((index: number) => {
      this.index = index;
      this.setState();
    }));
  }

  ngAfterContentInit() {
    // è®¢étabåæ¢äºä»¶ï¼å¦æåçåæ¢ï¼æ¾ç¤º/éèå¯¹åºè§å¾
    this.setState();
  }

  ngOnDestroy() {
    this.subs.forEach(item => item.unsubscribe());
  }

  setState() {
    this.tabViewItems?.forEach((item: TabViewItemComponent, i: number) => {
      item.active = i === this.index;
    });
  }
}
